import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createBlock as _createBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

import { PropType, computed } from 'vue'
import { PPTElement, PPTLineElement } from '@/types/slides'
import useCommonOperate from '@/views/Editor/Canvas/hooks/useCommonOperate'
import { OperateResizeHandlers } from '@/types/edit'

import BorderLine from '@/views/Editor/Canvas/Operate/BorderLine.vue'
import ResizeHandler from '@/views/Editor/Canvas/Operate/ResizeHandler.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MobileOperate',
  props: {
  elementInfo: {
    type: Object as PropType<Exclude<PPTElement, PPTLineElement>>,
    required: true,
  },
  isSelected: {
    type: Boolean,
    required: true,
  },
  canvasScale: {
    type: Number,
    required: true,
  },
  scaleElement: {
    type: Function as PropType<(e: MouseEvent, element: Exclude<PPTElement, PPTLineElement>, command: OperateResizeHandlers) => void>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const rotate = computed(() => 'rotate' in props.elementInfo ? props.elementInfo.rotate : 0)

const scaleWidth = computed(() => props.elementInfo.width * props.canvasScale)
const scaleHeight = computed(() => props.elementInfo.height * props.canvasScale)
const {
  borderLines,
  resizeHandlers: _resizeHandlers,
  textElementResizeHandlers,
} = useCommonOperate(scaleWidth, scaleHeight)

const resizeHandlers = props.elementInfo.type === 'text' || props.elementInfo.type === 'table' ? textElementResizeHandlers : _resizeHandlers

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "mobile-operate",
    style: _normalizeStyle({
      top: __props.elementInfo.top * __props.canvasScale + 'px',
      left: __props.elementInfo.left * __props.canvasScale + 'px',
      transform: `rotate(${_unref(rotate)}deg)`,
      transformOrigin: `${__props.elementInfo.width * __props.canvasScale / 2}px ${__props.elementInfo.height * __props.canvasScale / 2}px`,
    })
  }, [
    (__props.isSelected)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(borderLines), (line) => {
            return (_openBlock(), _createBlock(BorderLine, {
              class: "operate-border-line",
              key: line.type,
              type: line.type,
              style: _normalizeStyle(line.style)
            }, null, 8, ["type", "style"]))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(resizeHandlers), (point) => {
            return (_openBlock(), _createBlock(ResizeHandler, {
              class: "operate-resize-handler",
              key: point.direction,
              type: point.direction,
              rotate: __props.elementInfo.rotate,
              style: _normalizeStyle(point.style),
              onTouchstart: _withModifiers($event => __props.scaleElement($event, __props.elementInfo, point.direction), ["stop"])
            }, null, 8, ["type", "rotate", "style", "onTouchstart"]))
          }), 128))
        ], 64))
      : _createCommentVNode("", true)
  ], 4))
}
}

})